import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Card, CardContent, CardHeader} from '@mui/material';
import {styled} from '@mui/material/styles';
import {NodeViewContent, NodeViewWrapper} from '@tiptap/react';
import React from 'react';
import {useTranslation} from 'react-i18next';

import {MeaInfoColors, MeaInfoEnum, MeaInfoValues} from './mea-info-types';

export const MeaInfoComponent = (props: any) => {
  const type = props.node.attrs.type as MeaInfoEnum;
  const {t} = useTranslation();

  return (
    <NodeViewWrapper>
      <MeaCard className={`mea-info ${type}`}>
        <CardHeader
          title={
            <>
              {MeaInfoColors[type].icon && (
                <FontAwesomeIcon icon={MeaInfoColors[type].icon} style={{marginRight: '0.5em'}} />
              )}
              {t(`components.editor.mea-info.${type}`)}
            </>
          }
          className="infoblock-title"
        />
        <CardContent>
          <NodeViewContent as="div" className="infoblock-content" />
        </CardContent>
      </MeaCard>
    </NodeViewWrapper>
  );
};

const MeaCard = styled(Card)(() => ({
  borderLeft: '4px solid',
  padding: '0.5em 1em',
  margin: '1em 0',
  ...MeaInfoValues.reduce(
    (acc, type) => {
      acc[`&.${type}`] = {
        borderColor: MeaInfoColors[type].color,
        '& .infoblock-title': {
          color: MeaInfoColors[type].color,
        },
      };
      return acc;
    },
    {} as Record<string, any>,
  ),
}));
